<template>
  <div
    ref="scrollbar"
    :style="`position:relative;overflow-y:${
      noScrolling ? 'hidden' : 'auto'
    };background-color:${backgroundColor};width:${width};height:${height}`"
  >
    <slot></slot>
  </div>
</template>

<script>
import { debounce } from "quasar";
import mixin from "./d-card-mixins";
export default {
  name: "DScrollArea",
  mixins: [mixin],
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    storePath: {
      type: String,
      default: null,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    noScrolling: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lscrollPosition: 0,
    };
  },
  computed: {
    scrollPosition: {
      get() {
        if (this.behavior === "agent") {
          return this.lscrollPosition;
        } else {
          return this.$cardStore.get(this.storePath);
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lscrollPosition = val;
        } else {
          this.$cardStore.set(this.storePath, val);
        }
      },
    },
  },
  mounted() {
    if (this.behavior === "consumer") {
      this.$refs.scrollbar.style.scrollBehavior = "smooth";
      this.$watch("scrollPosition", (val) => {
        if (!this.$refs.scrollbar) {
          return;
        }

        this.$refs.scrollbar.scrollTop = val;
      });
    }
    this.$refs.scrollbar.addEventListener(
      "scroll",
      debounce((event) => {
        if (!this.$refs.scrollbar) {
          return;
        }

        this.$cardStore.set(this.storePath, this.$refs.scrollbar.scrollTop);
      }, 200)
    );
  },
};
</script>
<style scoped>
/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #aaa;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
</style>
